export const aggregatorInfos = {
    // TO DO : gérer le https
    // SPREADSHEET ID is a specific one for aggregator
    lysed: {
      front: [
        "http://localhost:3000",
        "http://lysed.mission-climat.io/",
        "https://lysed.mission-climat.io/",
      ],
      back: "http://localhost:4000",
      spreadsheetId: "1E0HeYFiCQ4wgMbYdMIWNbzMHdCnJoZP9Y-RODSWdtZY",
    },
    lysed_prod_heroku: {
      front: ["https://mc-lysed.herokuapp.com/", "http://mc-lysed.herokuapp.com//"],
      back: "https://mc-lysed.herokuapp.com",
      spreadsheetId: "1E0HeYFiCQ4wgMbYdMIWNbzMHdCnJoZP9Y-RODSWdtZY",
    },
    national: {
      front: ["http://mission-climat.io/", "https://mission-climat.io/"],
      back: "https://mission1degre5server.herokuapp.com",
      spreadsheetId: "1aXmD5u-MIiRPq0MYZ2DPFR7TWOVQezS8zJkgTLN-zHk",
    },
    ardennes: {
      front: [
        "http://localhost:3000",
        "http://mc-nord-ardennes.herokuapp.com/",
        "https://mc-nord-ardennes.herokuapp.com/",
      ],
      back: "http://localhost:4000",
      spreadsheetId: "10SVcBFNFa5_PdU354YeIo40RFfeLzV7x5qn1b1wQnu0",
    },
  };

export const addNonDisplayedValues = (values, jsonFile) => {
    let finalValues = [];
    let counter = 0;
    jsonFile.categories.map(cat => {
      cat.parameters.map(param => {
        if (param.data.displayed && values[counter]) {
          finalValues.push(values[counter])
          counter ++
        }
        else {
          finalValues.push([param.data.value])
        }
      })
    })
    return finalValues
  }